import {createEl} from '../createElement'
import {playAudio, stopTrack} from '../audio/playAudio'
import {memoryData} from 'memoryGame.data'
import {setSceneStatus} from '../utils'
import {createSprite} from '../sprites/playSprite'
import {hideHelpButton} from '../controls'
import {cueVideoCaptions} from '../captions'

function memoryGame() {

  const root = document.getElementById('root')

  // set scene status
  setSceneStatus('memoryGame')

  // load the outro video, since we're getting close to it
  const outroRoot = createEl('div', {id: 'outro'}, document.getElementById('root') )
  const outroVideo = createEl('video', {id: 'outro-video', src: '../media/video/outro.mp4', playsinline: true}, outroRoot)
  outroVideo.load()

  // create game root
  const gameRoot = createEl('div', {id: 'memory-game'}, root)

  // create buttons
  const button1 = createSprite('OrangeButton', gameRoot)
  button1.setAttribute('data-index', 1)
  const button2 = createSprite('GreenButton', gameRoot)
  button2.setAttribute('data-index', 2)
  const button3 = createSprite('PurpleButton', gameRoot)
  button3.setAttribute('data-index', 3)
  const button4 = createSprite('BlueButton', gameRoot)
  button4.setAttribute('data-index', 4)
  const launchButton = createSprite('LaunchButton', gameRoot)

  // start rounds
  playAudio('round2/vo_intro', {
    onEnd: () => {
      playRound(0, () => {
        enableLaunchButton()
      } )
    }
  })

  let roundRunning = false

  function playRound(roundNumber, allRoundsComplete) {

    if(roundRunning == true) {
      console.log('Round already running')
      return
    }

    roundRunning = true

    let listen = false

    if(roundNumber === memoryData.length) {
      allRoundsComplete()
      return
    }

    let round = memoryData[roundNumber]
    let buttonOrder = round.order
    glowButton(0) // ALWAYS start from index zero

    function glowButton(i) {
      let buttonNumber = buttonOrder[i]
      let button = document.querySelector(`button[data-index="${buttonNumber}"]`)
      button.setState('glow', {
        onEnd: () => {
          setTimeout( () => {
            if( typeof buttonOrder[i + 1] !== 'undefined' ) {
              glowButton(i + 1)
            }
            else {
              listen = true
            }
            button.setState('normal')
          }, round.interval)
        }
      })
    }

    // listen to clicks
    const listener1 = () => {
      buttonClick(button1)
    }
    const listener2 = () => {
      buttonClick(button2)
    }
    const listener3 = () => {
      buttonClick(button3)
    }
    const listener4 = () => {
      buttonClick(button4)
    }
    // touch events
    button1.addEventListener('touchstart', listener1)
    button2.addEventListener('touchstart', listener2)
    button3.addEventListener('touchstart', listener3)
    button4.addEventListener('touchstart', listener4)
    // pointer events
    if (! ( "ontouchstart" in document.documentElement) ) {
      button1.addEventListener('pointerdown', listener1)
      button2.addEventListener('pointerdown', listener2)
      button3.addEventListener('pointerdown', listener3)
      button4.addEventListener('pointerdown', listener4)
    }

    let clickIndex = 0

    function buttonClick(button) {
      if(listen !== true) {
        return
      }
      let buttonIndex = button.getAttribute('data-index')
      buttonIndex = parseInt(buttonIndex)
      if( buttonOrder[clickIndex] == buttonIndex ) { // correct click
        clickIndex++
        if(clickIndex == buttonOrder.length) { // end of round
          listen = false
          playAudio( round.correctAudio, {
            onEnd: () => {
              roundRunning = false
              endRoundAndPlayNext( {next: roundNumber + 1, correct: true}, allRoundsComplete )
            }
          } )
        }
      }
      else { // incorrect
        listen = false
        playAudio('round2/vo_incorrect', {
          onEnd: () => {
            roundRunning = false
            endRoundAndPlayNext( {next: roundNumber, correct: false}, allRoundsComplete )
          }
        })
      }
    }

    function endRoundAndPlayNext(props, allRoundsComplete) {
      // touch events
      button1.removeEventListener('touchstart', listener1)
      button2.removeEventListener('touchstart', listener2)
      button3.removeEventListener('touchstart', listener3)
      button4.removeEventListener('touchstart', listener4)
      // pointer events
      if (! ( "ontouchstart" in document.documentElement) ) {
        button1.removeEventListener('pointerdown', listener1)
        button2.removeEventListener('pointerdown', listener2)
        button3.removeEventListener('pointerdown', listener3)
        button4.removeEventListener('pointerdown', listener4)
      }
      let timeout = 600
      // once last round is over, make timeout 0
      if( props.next == memoryData.length ) {
        timeout = 0
      }
      setTimeout( () => {
        playRound(props.next, allRoundsComplete)
      }, timeout)
    }

  }

  function enableLaunchButton() {

    // pulse button
    const buttonInterval = setInterval( () => {
      launchButton.setState('hover')
      setTimeout( () => {
        launchButton.setState('normal')
      }, 500 )
    } , 1000 )

    const click = () => {
      launchButton.setState('click')
      launchButton.removeEventListener('click', click)
      hideHelpButton()
      stopTrack('music')
      stopTrack('ambience')
      playAudio('round2/sfx_launchButton')
      setTimeout( () => {
        clearInterval(buttonInterval)
        endGame()
      }, 500 )
    }
    launchButton.addEventListener('click', click)
  }

  // end game, clean up game resources
  function endGame() {
    gameRoot.parentNode.removeChild(gameRoot)

    // outro!
    const outroCaptions = {
      2500: "Now, Dasher! Now, Dancer! Now-- sorry, force of habit...",
      7000: "(jetpack starts)",
      8100: "Oh, Mrs. Claus! You are the egg to my nog, and the crisp air to my night.",
      18500: ""
    }
    setSceneStatus('outro')
    outroVideo.play()
    cueVideoCaptions(outroVideo, outroCaptions)
    outroVideo.addEventListener('ended', () => {
      window.location.reload()
    })
  }

}

export {memoryGame}
